module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<td>\n';
 bills.forEach(function(bill) { 
__p+='\n  <a class="bill-link" href="#bills/'+
((__t=( bill['bill_id'] ))==null?'':__t)+
'" oncontextmenu="return false">'+
((__t=( bill["document_type"] ))==null?'':__t)+
''+
((__t=( bill["number"] ))==null?'':__t)+
'</a>\n';
 }); 
__p+='\n</td>\n<td class="d-none d-sm-table-cell">'+
((__t=( caption ))==null?'':__t)+
'</td><!--hidden on xs screens -->\n<td>'+
((__t=( branch ))==null?'':__t)+
'</td>\n<td class="text-end">'+
((__t=( yeas ))==null?'':__t)+
'</td>\n<td class="text-end">'+
((__t=( nays ))==null?'':__t)+
'</td>\n<td class="text-end">'+
((__t=( excused ))==null?'':__t)+
'</td>\n<td class="text-end">'+
((__t=( not_voting ))==null?'':__t)+
'</td>';
}
return __p;
};
